module.exports = __webpack_public_path__ + "img/H2.0fb5b2b3.png";